import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Provider, ErrorBoundary } from '@rollbar/react';
import ReactGA from 'react-ga';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import ScrollToTop from './utils/scrollToTop';
import LoginModal from './components/loginModal';
import ShippingModal from './components/shippingModal';
import api from './services/api';
import { rollbarInstance, rollbarConfig, sendRollbarError} from './services/rollbar';
import { getQueryVariable } from './utils/location';

import { updateBrewingMethods } from './reducers/brewingMethods';
import { updateStates } from './reducers/states';
import { updateCoffees } from './reducers/coffees';
import { updateReferrer } from './reducers/referrer';
import { updateVoucher } from './reducers/voucher';
import { updateSubscription } from './reducers/subscription';
import { updateProducts } from './reducers/products';

import theme from './styles/theme';

import Step from './components/step';
import Container from './components/container';
import Main from './components/main';
import Header from './components/header';
import Chat from './components/chat';
import Footer from './components/footer';
import Profile from './components/profile';
import PageGateway from './components/pageGateway';
import Plan from './components/plan';
import CustomQuantity from './components/customQuantity';
import Customize from './components/customize';
import Frequency from './components/frequency';
import CustomFrequency from './components/customFrequency';
import BrewingMethod from './components/brewingMethod';
import Delivery from './components/delivery';
import Payment from './components/payment';
import Loading from './components/loading';

import Reset from './styles/Reset';

ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID);

function App() {
  const dispatch = useDispatch();
  const subscription = useSelector((state) => state.subscription);

  useEffect(() => {
    const params = {}
    const cupomParam = getQueryVariable('cupom');

    if(cupomParam || subscription.voucher){
      params.voucher_code = cupomParam || subscription.voucher;
    }

    api.post('/subscriptions/form', params).then((response) => {
      dispatch(updateBrewingMethods(response.data.preparation_types));
      dispatch(updateStates(response.data.states));
      dispatch(updateCoffees(response.data.coffee_beans));
      dispatch(updateProducts(response.data.products || []));

      if(response.data.referrer){
        dispatch(updateReferrer(response.data.referrer));
      }
      if(response.data.voucher){
        dispatch(updateVoucher(response.data.voucher));

        dispatch(updateSubscription({
          discountPrice: response.data.voucher.value,
          voucher: response.data.voucher.code,
        }));
      }
    }).catch((e) => {
      sendRollbarError('ERROR: /subscriptions/form', { message: e.message });
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Provider instance={rollbarInstance} config={rollbarConfig}>
      <ErrorBoundary>
        <ThemeProvider theme={theme}>
          <Router basename="/assinar">
            <ScrollToTop />
            <Reset />

            <Header />

            <Main>
              <Container>
                <Switch>
                  <Route path="/perfil">
                    <Step Component={Profile} step="1" />
                  </Route>
                  <Route path="/plano-gateway">
                    <PageGateway pageAttr="planPage" />
                  </Route>
                  <Route path="/plano">
                    <Step Component={Plan} step="2" />
                  </Route>
                  <Route path="/quantidade-personalizada">
                    <Step Component={CustomQuantity} step="2" />
                  </Route>
                  <Route path="/personalizar">
                    <Step Component={Customize} step="2" />
                  </Route>
                  <Route path="/frequencia-gateway">
                    <PageGateway pageAttr="frequencyPage" />
                  </Route>
                  <Route path="/frequencia">
                    <Step Component={Frequency} step="3" />
                  </Route>
                  <Route path="/frequencia-personalizada">
                    <Step Component={CustomFrequency} step="3" />
                  </Route>
                  <Route path="/metodo-de-preparo">
                    <Step Component={BrewingMethod} step="4" />
                  </Route>
                  <Route path="/entrega">
                    <Step Component={Delivery} step="5" />
                  </Route>
                  <Route path="/pagamento">
                    <Step Component={Payment} step="6" />
                  </Route>
                  <Route path="/">
                    <Step Component={Profile} step="1" />
                  </Route>
                </Switch>
              </Container>
            </Main>

            <Chat />
            <Footer />
            <LoginModal />
            <ShippingModal />

            <Loading />
          </Router>
        </ThemeProvider>
      </ErrorBoundary>
    </Provider>
  );
}

export default App;
